/**
 * SelectAllFilteredBanner
 *
 * Banner sutil debajo del header de la grilla del TodoList.
 * Aparece cuando el agente seleccionó todos los visibles cargados y existen más
 * contactos en el filtro completo (Gmail-style "select all").
 *
 * Props:
 * - visibleCount: cantidad de filas visibles cargadas
 * - totalCount: cantidad total que coincide con el filtro completo
 * - selectedCount: cantidad de checkboxes marcados (sin contar selectAllFiltered)
 * - selectAllFiltered: si está activo, muestra texto distinto + botón para deshacer
 * - onSelectAll: callback al click en "Seleccionar los X"
 * - onClearAll: callback al click en "Quitar selección"
 */
export default function SelectAllFilteredBanner({
  visibleCount,
  totalCount,
  selectedCount = 0,
  selectAllFiltered,
  onSelectAll,
  onClearAll
}) {
  // No banner si todo el filtro cabe en pantalla
  if (totalCount <= visibleCount) return null;

  // No banner si no hay seleccion bulk activa (solo aparece cuando todos los visibles estan marcados
  // o cuando ya esta en modo selectAllFiltered)
  if (!selectAllFiltered && selectedCount < visibleCount) return null;

  // Modo "filtro completo activo"
  if (selectAllFiltered) {
    return (
      <div className="bg-purple-50 dark:bg-purple-900/20 border-b border-purple-200 dark:border-purple-700 px-4 py-2 text-sm text-purple-900 dark:text-purple-200 flex items-center justify-between">
        <span>
          ✓ Seleccionados los <strong>{totalCount}</strong> contactos del filtro completo
        </span>
        <button
          onClick={onClearAll}
          className="text-purple-700 dark:text-purple-300 hover:underline font-medium"
          type="button"
        >
          Quitar selección
        </button>
      </div>
    );
  }

  // Modo "solo visibles" — propone expandir
  return (
    <div className="bg-purple-50 dark:bg-purple-900/20 border-b border-purple-200 dark:border-purple-700 px-4 py-2 text-sm text-purple-900 dark:text-purple-200 flex items-center justify-between">
      <span>
        Seleccionados los {visibleCount} visibles.
      </span>
      <button
        onClick={onSelectAll}
        className="text-purple-700 dark:text-purple-300 hover:underline font-medium"
        type="button"
      >
        Seleccionar los {totalCount} que coinciden con el filtro ↗
      </button>
    </div>
  );
}
